import type { ExcelGridColGroupProps } from "../models/excel-grid-component-props.models";

export const ExcelGridColGroup = ({ columns, columnWidths }: ExcelGridColGroupProps) => (
  <colgroup>
    {columns.map((column) => (
      <col key={column.key} width={columnWidths[column.key]} />
    ))}
  </colgroup>
);
